import * as React from 'react';
import ReactDOM from 'react-dom';
import { css } from "@emotion/core";

const Portal = ({ children, overlayStyle, nodeName = 'BODY' }) =>
  ReactDOM.createPortal(
    <div css={css(overlayStyle)}>{children}</div>,
    document.getElementsByTagName(nodeName)[0]
  );

export default Portal;
